import { apiConfig } from '../defineConfig';

interface ISetup {
  apiUrl?: (() => string) | string;
}

export function defineApiUrl<S extends ISetup = ISetup>(setup?: S): () => string {
  if (setup && setup.apiUrl) {
    if (typeof setup.apiUrl === 'function') {
      return setup.apiUrl;
    } else {
      const apiUrl = setup.apiUrl;
      return () => apiUrl;
    }
  }

  return () => {
    return apiConfig.apiUrl ?? '';
  };
}
